export default __webpack_public_path__ + "static/blob-22-a2a462c37ace34ebe4b427edb34ea1b5.svg";